import React from 'react';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import { fetchCountrySites, resetCountrySiteSearch } from '../provider/actions';
import { Autocomplete, TextField } from 'components/Input';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
  },
});

const CountrySearch = (props) => {
  const classes = useStyles();
  const {
    options = [],
    trial_id,
    language,
    fetchTrialCountrySites,
    resetCountrySearch,
    placeholder = 'Choose a country',
  } = props;

  const onChange = (e, item, reason) => {
    if (item) {
      fetchTrialCountrySites({ trial_id, language, country: item.value });
    } else {
      resetCountrySearch();
    }
  };
  return (
    <Grid xs={12} item>
      <Autocomplete
        id="country-select"
        background="light"
        onChange={onChange}
        style={{ minWidth: 120, width: '100%' }}
        options={options}
        classes={{
          option: classes.option,
        }}
        autoHighlight
        getOptionLabel={(option) => option.label}
        renderOption={(option) => (
          <Grid
            container
            spacing={2}
            justify="space-between"
            alignItems="center"
          >
            <Grid item>{option.label}</Grid>
            <Grid item>
              <Chip label={option.count} size="small" variant="outlined" />
            </Grid>
          </Grid>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant="filled"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'off', // disable autocomplete and autofill
            }}
          />
        )}
      />
    </Grid>
  );
};
function mapStateToProps({ trial }) {
  return {
    trial_id: trial.id,
    language: trial.language,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchTrialCountrySites: (obj) => dispatch(fetchCountrySites(obj)),
    resetCountrySearch: () => dispatch(resetCountrySiteSearch()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CountrySearch);
